import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CLASS_HOME_GET',
  GET_SUCCESS: 'CLASS_HOME_GET_SUCCESS',
  GET_FAILURE: 'CLASS_HOME_GET_FAILURE',
  INVALIDATE_ITEM: 'CLASS_HOME_INVALIDATE_ITEM',
} as const;

export const get = actions.get((id: string) => `${BASE_URL}/students/${id}/class-home/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = (id: string) => ({
  type: ACTIONS.INVALIDATE_ITEM,
  payload: {
    id,
  },
});
